import { computed, Injectable, signal } from "@angular/core";
import { PartnerPublicRequestContext, PartnerPublicRequestSubmitResponse } from "../Dto/PartnerPublicRequestModel";
import { PartnerPublicRequestStateModel } from "../Dto/PartnerPublicRequestStateModel";

const initialState: PartnerPublicRequestStateModel = {
  context: null,
  submitResult: null,
  loading: false,
  submitting: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class PartnerPublicRequestState {
  private readonly state = signal<PartnerPublicRequestStateModel>(initialState);

  readonly context = computed(() => this.state().context);
  readonly submitResult = computed(() => this.state().submitResult);
  readonly loading = computed(() => this.state().loading);
  readonly submitting = computed(() => this.state().submitting);
  readonly error = computed(() => this.state().error);

  setContext(context: PartnerPublicRequestContext): void {
    this.state.update((state) => ({
      ...state,
      context,
      submitResult: null,
      error: null,
    }));
  }

  setSubmitResult(submitResult: PartnerPublicRequestSubmitResponse): void {
    this.state.update((state) => ({
      ...state,
      submitResult,
      error: null,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setSubmitting(submitting: boolean): void {
    this.state.update((state) => ({ ...state, submitting }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  reset(): void {
    this.state.set({ ...initialState });
  }
}
